
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/teamsreminder-customer-success-client-followups",
      function () {
        return require("private-next-pages/article/teamsreminder-customer-success-client-followups.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/teamsreminder-customer-success-client-followups"])
      });
    }
  